import React from 'react';
import Button from '../Button';
import Image from '../Image';
import AreaBox from '../AreaBox';
import Spinner from '../Spinner';
import { request } from 'axios/request';
import * as utils from '../utils';

const widgets = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/widgets`);
const urls = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/integrationMaps/urls`);

const { objectSelector } = utils;
const INVALID_PROPS = 'Invalid Props';

const Widget = (params) => {
  const { path, paths, props, component, components } = params;
  let candidateComponents = [];

  switch (true) {
    case !!path && typeof path === 'string': {
      const _components = [objectSelector(widgets, path, null)];
      candidateComponents = _components;

      break;
    }
    case !!paths && Array.isArray(paths): {
      const _components = paths.map((path) =>
        objectSelector(widgets, path, null)
      );
      candidateComponents = _components;

      break;
    }
    case !!component && typeof component === 'function': {
      candidateComponents = [component];

      break;
    }
    case !!components && Array.isArray(components): {
      candidateComponents = components;

      break;
    }
    default: {
      candidateComponents = [() => <p className='error'>{INVALID_PROPS}</p>];
    }
  }

  const _props = {
    Button,
    Image,
    AreaBox,
    Spinner,
    request,
    urls,
    utils,
    ...props,
  };

  const availableComponents = candidateComponents
    .filter((item) => !!item)
    .map((item, i) => {
      const Comp = item.default;
      return <Comp key={i} {..._props} />;
    });

  return availableComponents;
};

export default Widget;



// WEBPACK FOOTER //
// ./src/theme/widgets/index.js